import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Employees';

export const employeeEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  /** Action-scope (manage-* ladder) — used to populate transaction Add/Edit dropdowns. */
  scoped: () => buildEndpoint(`${BASE_PATH}/scoped`),
  /** View-scope (view-* ladder) — used to populate list filters, report filters, dashboards. */
  visible: () => buildEndpoint(`${BASE_PATH}/visible`),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  /** Termination preview — pass ?dateLeft=YYYY-MM-DD via the service layer. */
  terminationPreview: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/termination-preview`, { id }),
  terminate: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/terminate`, { id }),
  basePath: () => BASE_PATH,
} as const;

export default employeeEndpoints;
